import { FiAlertCircle } from "react-icons/fi";
type PropsType = {
  message: string;
  /** Recherche catalogue et panier : fond bleu, plus le jaune. */
  variant?: "info" | "catalog";
};
export function AlertInfo({ message, variant = "info" }: PropsType) {
  const tone = variant === "catalog" ? "catalog" : "info";
  return (
    <div className="px-3 w-100">
      <div className={`easy-market-alert easy-market-alert-${tone}`} role="alert">
        <FiAlertCircle style={{ fontSize: 24 }} />
        <h4>{message}</h4>
      </div>
    </div>
  );
}
